import { Component, OnInit, Input, ElementRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DashboardQueries } from '../../../shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
//import { WidgetSearch } from '../../../shared/models/WidgetSearch';
import { DashboardService } from '../../../shared/services/dashboard.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { DashboardWidgetService } from '../../../shared/services/dashboardWidget.service';
//import { Item } from '@progress/kendo-angular-grid/dist/es2015/data/data.iterators';
import { filterItem } from '@app/cp/shared/models/filterItem';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DataItem } from '@progress/kendo-angular-grid';

import { FeatureFlagService } from '@app/cp/shared/services/feature-flag.service';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({

    selector: 'cp-dispatch-reftrack',
    templateUrl: './dispatch-reftrack.component.html',
    styleUrls: ['./dispatch-reftrack.component.scss']
})
export class DispatchReftrackComponent implements OnInit, OnDestroy {

    constructor(private globals: GlobalsService, private svc_data: DashboardService, private svc_dashWidget: DashboardWidgetService, private el: ElementRef, qry_rd: DQOIReferenceDataQuery, private featureFlagService: FeatureFlagService) {
        this.qry_rd = qry_rd;
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });
    }

    @Input() chartType: string = 'donut';
    @Input() detailsTitleStart: string = '';
    @Input() inputSearchParams: WidgetSearch;
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    subs_dataRefUpdated: Subscription;
    widgetQuery: DashboardQueries;
    chartSearchFilters: widgetFilters[];

    show: boolean = false;
    searchParam: WidgetSearch;
    data: DataItem[];
    gridData: any;

    acctManagerFilters: any;
    customerFilters: any;
    acctClassFilters: any;
    srvConstFilters: any;
    dispatchStatusFilters: any;
    divisionFilters: any;
    regionFilters: any;
    onCallRegionFilters: any;
    coordinatorFilters: any;

    detailsTitle: string;
    detailsActive: boolean = false;
    selectedFilters: WidgetSearch;
    public windowData: any = {};
    public showDetails: boolean = false;
    public showWindow: boolean = false;
    public activeChildComp: number;
    public contentTypes = WindowContents;
    public dashboardQuery: DashboardQueries = DashboardQueries.dispatchreftracking; //.dispatchStatusGauge;

    subs_dataRef: Subscription;
    qry_rd: DQOIReferenceDataQuery;
    referenceData: DQOIReferenceData;

    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();

    loaderError: boolean = false;
    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};

    ngOnInit() {
        //this.search(this.searchParam);
        console.log("ngOnInit(): ", this.inputSearchParams);
        if (this.inputSearchParams) {
            this.searchParam = this.inputSearchParams;
        }
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
            this.featureFlagSet = data;
            this.loadWidgetFilters();
            this.loadDashboardQueries();
        });
    }
    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }
    private loadDashboardQueries() {
        this.widgetQuery = this.featureFlagSet["dispatch-reftracking-oncall"] ? DashboardQueries.dispatchreftracking_v2 : DashboardQueries.dispatchreftracking;
    }
    private loadWidgetFilters() {
        this.chartSearchFilters = this.featureFlagSet["dispatch-reftracking-oncall"] ?
            [
                widgetFilters.customer,
                widgetFilters.divisions,
                widgetFilters.regions,
                widgetFilters.class,
                widgetFilters.status,
                widgetFilters.svcConst,
                widgetFilters.acctMgr,
                widgetFilters.contAdmin,
                widgetFilters.onCallRegion
            ]
            :
            [
                widgetFilters.customer,
                widgetFilters.divisions,
                widgetFilters.regions,
                widgetFilters.class,
                widgetFilters.status,
                widgetFilters.svcConst,
                widgetFilters.acctMgr,
                widgetFilters.contAdmin,
                widgetFilters.onCallRegion
            ];        
    }
    public refresh() {
        this.search(this.searchParam);
    }

    search(searchParam: WidgetSearch) {
        console.log("search(): ", searchParam);
        this.searchParam = searchParam;
        this.searchParams.emit(searchParam);
        console.log("widgetQuery: ", this.widgetQuery);
        if (this.searchParam.customSearch || this.searchParam.emptySearch) {
            this.show = false;
            this.showSpinner();
            this.svc_data.getDashboardQuery(this.widgetQuery, this.searchParam).subscribe((info: any) => {
                if (this.featureFlagSet["dispatch-reftracking-oncall"]) {
                    if (!info.success) {
                        this.handleNetworkError(info.message);
                    }
                    else {
                        console.log("widget-reftrack-agd: ", info, this.widgetQuery);
                        this.data = info.result;
                    }
                }
                else {
                    if (info.saveError) {
                        this.handleNetworkError(info.messages);
                    }
                    else {
                        console.log("widget-reftrack-agd: ", info, this.widgetQuery);
                        this.data = info.primaryReturn;
                    }
                }

                this.setFilteredItemsDisplay();

                this.hideSpinner();
            },
                error => this.handleNetworkError(error));
        } else {
            this.show = true;
            this.hideSpinner();
        }

    }

    handleNetworkError(error) {

        this.hideSpinner();
        this.showError();
    }

    showSpinner() {
        this.loaderState.emit(true);
    }

    hideSpinner() {
        this.loaderState.emit(false);
    }

    showError() {
        this.loaderError = true;
        this.loaderErrorState.emit(this.loaderError);
    }

    hideError() {
        this.loaderError = false;
        this.loaderErrorState.emit(this.loaderError);
    }

    public onToggle(): void {
        this.show = !this.show;
    }
    getDetailData() {
        this.setDetailData('');
    }
    setDetailData(category?: string) {
        this.showSpinner();
        let filter = new filterItem();
        filter.field = "Status";
        if (category) {
            filter.value = category;
            this.searchParam.out_S = filter.value;
            this.detailsTitle = this.detailsTitleStart + filter.value;
        }
        this.detailsActive = true;
        this.selectedFilters = this.searchParam;
        this.windowData.selectedFilters = this.selectedFilters;
        this.windowData.dashboardQuery = this.dashboardQuery;
        if (this.gridData) {
            this.windowData.gridData = this.gridData;
        }
        this.popWindow();

        this.hideSpinner();
    }
    popWindow() {
        this.activeChildComp = this.contentTypes.chartWidget;
        this.showWindow = true;
        this.svc_data.disableDragging = true;
    }

    public onGridButtonClick() {
        this.showSpinner();
        this.getDetailData();
    }

    onClosed(e) {
        this.search(this.searchParam);
        this.showWindow = false;
        this.svc_data.disableDragging = false;
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

    setFilteredItemsDisplay() {
        this.acctManagerFilters = CommonFunctions.findInObjArr(this.referenceData.acctMgrs, this.searchParam.acctMgrIds);
        this.customerFilters = CommonFunctions.findInObjArr(this.referenceData.customers, this.searchParam.customerIds);
        this.acctClassFilters = CommonFunctions.findInObjArr(this.referenceData.accountClasses, this.searchParam.classIds);
        this.srvConstFilters = CommonFunctions.findInObjArr(this.referenceData.srvConst, this.searchParam.srvConstInt);
        this.dispatchStatusFilters = CommonFunctions.findInObjArr(this.referenceData.dispatchStatus, this.searchParam.statusIds);
        this.divisionFilters = CommonFunctions.findInObjArr(this.referenceData.divisions, this.searchParam.divisionIds);
        this.regionFilters = CommonFunctions.findInObjArr(this.referenceData.regions, this.searchParam.regionIds);
        this.onCallRegionFilters = CommonFunctions.findInObjArr(this.referenceData.onCallRegions, this.searchParam.onCallRegions);
        this.coordinatorFilters = CommonFunctions.findInObjArr(this.referenceData.contAdmins, this.searchParam.contractAdminIds);
    }
    
}
